import { createStyleSheet } from '@shared-ui/theme'
import { rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme) => ({
  root: {
    backgroundColor: theme.COLOR_BG_SURFACE,
    borderRadius: rw(theme.SIZE_BUTTON_BORDER_RADIUS),
    minHeight: rh(52),
    paddingHorizontal: rw(16),
    alignItems: 'center',
    justifyContent: 'center',
  },
  disabled: { color: theme.COLOR_TEXT_DISABLED },
}))
